import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import { vRdxUserInfo } from "../../Redux/roStore";
import {
  GetItemFullSearchArr,
  fItemCodeDependency,
  GetSearchItem,
  GetUnitArr,
  fValidationDetail_Client,
  fValidationHead_Client,
  //item
  GCToggleSearch_ItemName_Columns,
  GCToggleSearch_ItemName_Select_Arr,

  //save
  fSaveHead,
  fLoad_Grid,
  get_Fdisplay,
} from "./WmsPutAwayAction";
import {
  fAlertToast,
  fcovertToNumber,
  fcheck_null_undefine_replace_empty,
  GetGitterColumns,
  Get_ToggleDropDown_binsearch_Load,
} from "../../Utility/Utilitys";
import React, { useState, useEffect, useRef, useCallback } from "react";

import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import WmsHead from "./processComponent/WmsHead";
import WmsContent from "./processComponent/WmsContent";

import "./WmsPutAway.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import WmsPutAwayBreadCrumbs from "./processComponent/WmsPutAwayBreadCrumbs";
import { useLocation } from "react-router-dom";
import { fExecuteAPI } from "../../Server/Apis";

export default function WmsPutAwayDetail() {
  const BarcodeFocusOnLoad = useRef(null);
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const location = useLocation();
  const { VocTyp = "", VocNo = "" } = !!location.state
    ? location.state
    : {
        VocTyp: "",
        VocNo: "",
      };
  const [vRdxHead, setHead] = useState({
    VocName: "",
    A_VocNo: "",
    PA_DocDt: "",
    A_Loc: "",
    LocName: "",
    PA_DocStat: "",
    A_VocTyp: "",
    PA_Typ: "",
    UBAY: "",
    UBAYName: "",
  });

  const sEnterKeyObj = {
    key: "Enter",
  };

  const [sDetail_Grid_Row, setDetail_Grid_Row] = useState([]);
  const sRoundingVal = 4;
  const fDetail_Grid_onRowClick = async (item) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Srno: item.row.R_Srno,
      B_Itmcd: item.row.R_Itmcd,
      B_ItmName: item.row.ItemName,
      B_Qty: item.row.R_Qty,
      B_Unit: item.row.R_Unit,
      B_UnitName: item.row.UnitName,
      B_BaseQty: item.row.R_BaseQty,
    }));
    let currentUnitArr = await GetUnitArr(item.row.R_Itmcd, setUnit);
    let vUnitvalue = currentUnitArr.find((obj) => {
      return obj.Unit === item.row.R_Unit;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      B_Packing: vUnitvalue.PackDesc,
    }));
    fCloseViewModal();
  };

  let vBufferObjInit = {
    B_CardId:"",
    B_Srno: 0, // int
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: (0).toFixed(sRoundingVal), //Decimal
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_Packing: 0, //Decimal
    B_BaseQty: 0, //Decimal
    BatchNo: "",
    GRNQty: "",
    PutawayQty: "",
    BalanceQty: "",
    Bincode: "",
    B_BinName:"",
  };

  const [sBufferObj, setBufferObj] = useState(vBufferObjInit);

  const [sUnit, setUnit] = useState([]);
  const fContent_Focus = (e) => {
    if (Number(e.target.value) === 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };

  const fContent_Blur = (e) => {
    if (e.target.value === "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
    }
  };
  const fUnit = async (e) => {
    let vUnitvalue = sUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      B_Packing: vUnitvalue?.PackDesc,
    }));
  };

  const fQty = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Qty: e.target.value,
    }));
  };
  const fQty_Enter = (e) => {
    if (e.key === "Enter") {
      fSave();
      document.getElementsByName("B_Qty")[0].blur();
    }
  };

  const fCardId_BackSpace_Clear = () => {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: "",
      B_ItmName: "",
      B_Qty: (0).toFixed(sRoundingVal), //Decimal
      B_Unit: "",
      B_UnitName: "",
      B_PackQty: (0).toFixed(sRoundingVal), //Decimal
      B_Packing: 0, //Decimal
      B_BaseQty: 0, //Decimal
      BatchNo: "",
      GRNQty: "",
      PutawayQty: "",
      BalanceQty: "",
    }));
    setUnit([]);
  };
   const GetCartIDDetail = async (xCardId, xBSrno = "0") => {
      const CartBarcodeDetailObj = {
        vocTyp: vRdxHead.A_VocTyp,
        vocNo: vRdxHead.A_VocNo,
        srNo: xBSrno,
        cardId: xCardId,
      };
      const CartBarcodeDetail = await fExecuteAPI(
        "PUTAWAY_getCardDetail_GETROW",
        CartBarcodeDetailObj
      );
      if (CartBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
        if (CartBarcodeDetail.ResultSet.length > 0) {
          setBufferObj((obj) => ({
            ...obj,
            B_Itmcd: CartBarcodeDetail.ResultSet[0].ItmCd,
            B_ItmName: CartBarcodeDetail.ResultSet[0].Name2,
            B_BatchNo: CartBarcodeDetail.ResultSet[0].BatchNo,
            B_GrnQty: CartBarcodeDetail.ResultSet[0].GRN,
            PutawayQty: CartBarcodeDetail.ResultSet[0].PutAwayQty,
            BalanceQty: CartBarcodeDetail.ResultSet[0].BalanceQty,
            // SuppRefNo1: CartBarcodeDetail.ResultSet[0].SuppRefNo1,
            // v_P_ExpDt: CartBarcodeDetail.ResultSet[0].ExpDt,
          }));
  
          let vItemSearchFull = await GetItemFullSearchArr(
            CartBarcodeDetail.ResultSet[0].ItmCd,
            vRdxHead.A_Loc
          );
  
          if (vItemSearchFull.length > 0) {
            fItemCodeDependency(
              vItemSearchFull,
              setBufferObj,
              setUnit,
              CartBarcodeDetail.ResultSet[0].Unit
            );
          }
        } else {
          fCardId_BackSpace_Clear();
          fAlertToast("WARNING", "Wrong card Id");
        }
      } else {
        if (!!CartBarcodeDetail?.Message) {
          fAlertToast("FAILED", CartBarcodeDetail?.Message);
        } else {
          fAlertToast("FAILED", CartBarcodeDetail.response.data.message);
        }
      }
    };
  const fCardIdEnter = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      if (sBufferObj.CardId === "") {
        fAlertToast("FAILED", "CardID is empty");
      } else {
        GetCartIDDetail(sBufferObj.B_CardId);
      }
    } else if (e.key == "Backspace") {
      fCardId_BackSpace_Clear();
    }
  };

  //Modal ItemSearch start
  const [
    GCToggleSearch_ItemName_Grid_Row,
    set_GCToggleSearch_ItemName_Grid_Row,
  ] = useState([]);
  //Item Dropdowm
  const [GCToggleSearch_ItemName_Toggle, set_GCToggleSearch_ItemName_Toggle] =
    useState(false);
  const [GCToggleSearch_ItemName_Obj, set_GCToggleSearch_ItemName_Obj] =
    useState({
      Type: "Any",
      Data: "",
    });
  const Toggle_ItemSearch = () => {
    if (GCToggleSearch_ItemName_Toggle) {
      set_GCToggleSearch_ItemName_Toggle(false);
      set_GCToggleSearch_ItemName_Grid_Row([]);
      set_GCToggleSearch_ItemName_Obj({
        Type: "Any",
        Data: "",
      });
    } else {
      set_GCToggleSearch_ItemName_Toggle(true);
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  };

  const GCToggleSearch_ItemName_Sub_Input = (e) => {
    set_GCToggleSearch_ItemName_Obj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fItemToggleClick = (e) => {
    set_GCToggleSearch_ItemName_Grid_Row([]);
    set_GCToggleSearch_ItemName_Obj((obj) => ({
      ...obj,
      Data: sBufferObj.B_ItmName,
    }));

    if (sBufferObj.B_ItmName != "") {
      GetSearchItem(
        sBufferObj.B_ItmName,
        "Any",
        vRdxHead.A_Loc,
        set_GCToggleSearch_ItemName_Grid_Row
      );
    }

    Toggle_ItemSearch();
  };

  //ItemSearch
  const GCToggleSearch_ItemName_Main_Enter = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        sBufferObj.B_ItmName,
        vRdxHead.A_Loc
      );

      if (vItemSearchFull.length > 0) {
        fItemCodeDependency(vItemSearchFull, setBufferObj, setUnit);
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: "",
        B_ItmName: e.target.value,
        B_Unit: "",
        B_UnitName: "",
        B_PackQty: "",
      }));
      setUnit([]);
    }
  };

  //Item search Start
  const GCToggleSearch_ItemName_Main_Input = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ItmName: e.target.value,
    }));
  };

  const GCToggleSearch_ItemName_RowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(e.row.ItmCd, vRdxHead.A_Loc);
    if (vItemSearchFull.length > 0) {
      fItemCodeDependency(vItemSearchFull, setBufferObj, setUnit);
      document.getElementsByName("B_Qty")[0]?.focus();
    } else {
      document.getElementsByName("B_ItmName")[0]?.focus();
    }
    set_GCToggleSearch_ItemName_Toggle(false);
  };
  //GCItemSearch
  const GCToggleSearch_ItemName_CellClick = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      GCToggleSearch_ItemName_RowClick(newSelectionModel);
    }
  };
  const GCToggleSearch_ItemName_Sub_Enter = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        GCToggleSearch_ItemName_Obj.Data,
        GCToggleSearch_ItemName_Obj.Type,
        vRdxHead.A_Loc,
        set_GCToggleSearch_ItemName_Grid_Row
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  //Item search end

  let timeout = null;
  const fSave = async (e) => {
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (vRdxHead?.A_DocStat?.toUpperCase() !== "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " + vRdxHead?.A_DocStat + " mode"
        );
        return;
      }

      let validation = fValidationHead_Client(vRdxHead, vMediaQuery, fSummary);

      if (!validation) return;

      let validationDetil = fValidationDetail_Client(sBufferObj);

      if (!validationDetil) return;

      fSaveHead(fNewDetail, sBufferObj);
    }, 500);
  };

  const fApprove = async (e) => {
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (sBufferObj.B_Itmcd !== "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }

      if (sDetail_Grid_Row.length === 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }
      let validation = fValidationHead_Client(vRdxHead, vMediaQuery, fSummary);

      if (!validation) return;
    }, 500);
  };

  const fNew = async () => {
    fNewDetail();
    document?.getElementsByName("B_Qty")[0]?.focus();
  };
  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };
  //Modal View
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  //vTaxType  vTaxType ==  sTax[1].Uid then tax %0
  const fNewDetail = () => {
    setBufferObj(vBufferObjInit);

    setUnit([]);

    fLoad_Grid(setDetail_Grid_Row);

    document.getElementsByName("B_Qty")[0]?.focus();
  };

  const fDelete = (e) => {
    if (vRdxHead.A_DocStat === "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    } else if (sBufferObj.B_Srno === 0) {
      fAlertToast("FAILED", "Item not selected");
      return;
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete line item.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              fDeleteDetail();
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  //DELETESIDETAIL_GETROW
  const fDeleteDetail = async () => {
    const vRdxUserInfoObj = vRdxUserInfo();
    let vDeleteSIDetailObj = {
      v_B_VocTyp: vRdxHead.DocType,
      v_B_VocNo: vRdxHead.DocNo,
      v_B_Srno: sBufferObj.B_Srno,
      v_UserCd: vRdxUserInfoObj.UserID,
      v_IP: vRdxUserInfoObj.IP,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIDetailObj);
    const vDeleteSIDetail = {};
    // await WmsPutAway_DeleteDetail_GETROW(
    //   FinalObj
    // );

    if (vDeleteSIDetail?.status === 200) {
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
      fNewDetail();
    }
  };
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {
      // WMS/PutAway?prntyp=PUAWAY_GRN&voctyp=WG001&vocno=B990000003&reporttile=PutAway%20Report
      let urlPrint =
        vRdxDBKernObj?.WEB_REPORT_BASE_URL?.Val +
        "WMS/PutAway?prntyp=" +
        xPrnTyp +
        "&voctyp=" +
        vRdxHead?.DocType +
        "&vocno=" +
        vRdxHead?.DocNo +
        "&reporttile=PutAway Report";
      setWebReportUrlModal(urlPrint);
      fWebReport();
    },
    [vRdxHead?.DocType, vRdxHead?.DocNo, vRdxDBKernObj]
  );

  //esc keyZ close item dropdown
  const escFunction = useCallback((event) => {
    if (event.key === "Escape") {
      set_GCToggleSearch_ItemName_Toggle(false);
      set_GCToggleSearch_ItemName_Grid_Row([]);
    }
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (GCToggleSearch_ItemName_Toggle) {
        const toggleElement = event.target.closest(".toggleSearch");

        if (!toggleElement) {
          set_GCToggleSearch_ItemName_Toggle(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [GCToggleSearch_ItemName_Toggle]);

  useEffect(() => {
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty: fcovertToNumber(sBufferObj.B_Qty * sBufferObj.B_PackQty),
    }));
  }, [sBufferObj.B_Qty, sBufferObj.B_PackQty]);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  useEffect(() => {
    BarcodeFocusOnLoad?.current?.focus();
  }, []);

  const [Detail_Grid_columns, setDetail_Grid_columns] = useState([
    {
      field: "R_Srno",
      headerName: "Sr No",
      width: 50,
      hide: vMediaQuery ? true : false,
    },
    {
      field: "R_Itmcd",
      headerName: "Item Code",
      width: 90,
      hide: true,
    },
    {
      field: "ItemName",
      headerName: "Item Name",
      width: 320,
    },
    {
      field: "R_Qty",
      headerName: "Qty",
      width: 50,
      valueFormatter: ({ value }) => {
        Number(value)?.toFixed(Number(3));
      },
    },

    {
      field: "R_Unit",
      headerName: "Unit",
      width: 100,
    },
    {
      field: "UnitName",
      headerName: "UnitName",
      width: 100,
    },
    {
      field: "R_BaseQty",
      headerName: "Base Qty",
      width: 100,
      hide: vMediaQuery ? true : false,
    },
  ]);

  useEffect(() => {
    GetGitterColumns(setDetail_Grid_columns, "INV10RCDWB", Detail_Grid_columns);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onload = async () => {
    const fdisplay = await get_Fdisplay(VocTyp, VocNo);
    if (fdisplay.length > 0) {
      setHead((prev) => ({
        ...prev,
    //     VocName: "",
    // A_VocNo: "",
    // PA_DocDt: "",
    // A_Loc: "",
    // LocName: "",
    // PA_DocStat: "",
    // A_VocTyp: "",
    // PA_Typ: "",
    // UBAY: "",
    // UBAYName: "",
        ...fdisplay[0],
      }));
      fLoad_Grid(fdisplay[0].A_VocTyp, fdisplay[0].A_VocNo, setDetail_Grid_Row);
    }
  };
  useEffect(() => {
    onload(VocTyp, VocNo);
  }, []);

  //bin
  const [
    sGC_Toggle_Head_BinName_ToggleDropDowm,
    setGC_Toggle_Head_BinName_ToggleDropDowm,
  ] = useState(false);

  const [
    sGC_Toggle_Head_BinName_SearchDropdownObj,
    setGC_Toggle_Head_BinName_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });

  const [sGC_Toggle_Head_BinName_GridData, setGC_Toggle_Head_BinName_GridData] =
    useState([]);
  // const [
  //   sGC_Toggle_Head_BinName_ToggleDropDowm,
  //   setGC_Toggle_Head_BinName_ToggleDropDowm,
  // ] = useState(false);

  const xfGC_Toggle_Head_BinName_Toggle = useCallback(() => {
    if (sGC_Toggle_Head_BinName_ToggleDropDowm) {
      setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      set_GCToggleSearch_ItemName_Obj(false);
      setGC_Toggle_Head_BinName_GridData([]);
      setGC_Toggle_Head_BinName_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGC_Toggle_Head_BinName_ToggleDropDowm(true);
      set_GCToggleSearch_ItemName_Obj(false);
    }
  }, [sGC_Toggle_Head_BinName_ToggleDropDowm]);

  //2nd call
  const fGC_Toggle_Head_BinName_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGC_Toggle_Head_BinName_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sBufferObj.B_BinName,
      }));
      if (sBufferObj.B_BinName != "") {
        const vExactSearch = await Get_ToggleDropDown_binsearch_Load(
          sBufferObj.B_BinName,
          "Any",
          "N",
          sBufferObj.A_Loc
        );

        if (vExactSearch.length > 0) {
          setGC_Toggle_Head_BinName_GridData(vExactSearch);
        } else {
          setGC_Toggle_Head_BinName_GridData([]);
        }
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfGC_Toggle_Head_BinName_Toggle();
    }
  };

  //1stcall
  const fGC_Toggle_Head_BinName_onKeyUp = async (e) => {
    // fBinNameKey(e);
    if (e.key === "Enter" || e._reactName === "onClick") {
      const vExactSearch = await Get_ToggleDropDown_binsearch_Load(
        sBufferObj.B_BinName,
        "Any",
        "Y",
        sBufferObj.A_Loc
      );

      if (vExactSearch.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_BinCode: vExactSearch[0].UId,
          B_BinName: vExactSearch[0].Name1,
        }));
      } else {
        fGC_Toggle_Head_BinName_Dropdown_SearchModalKey(e);
      }

      // if (sBufferObj.B_BinCode != "") {
      //   setTimeout(() => {
      //     fKeyTabInput(e, "B_ItmName");
      //   }, 500);
      // }
    }
    if (e.key === "Backspace") {
      setBufferObj((obj) => ({
        ...obj,
        B_BinCode: "",
        B_CardId: "",
      }));
      // fCardId_BackSpace_Clear();
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGC_Toggle_Head_BinName_Dropdown_onChange = (e) => {
    setGC_Toggle_Head_BinName_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vExactSearch = await Get_ToggleDropDown_binsearch_Load(
        sGC_Toggle_Head_BinName_SearchDropdownObj.Data,
        sGC_Toggle_Head_BinName_SearchDropdownObj.Type,
        "N",
        sBufferObj.A_Loc
      );

      if (vExactSearch.length > 0) {
        setGC_Toggle_Head_BinName_GridData(vExactSearch);
      } else {
        setGC_Toggle_Head_BinName_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const fGC_Toggle_Head_BinName_OnRowClick = async (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_BinCode: e?.row?.UId,
      B_BinName: e?.row?.Name1,
    }));
    xfGC_Toggle_Head_BinName_Toggle();
    setTimeout(() => {
      document?.getElementsByName("B_Batch")[0]?.focus();
    }, 500);
  };

  const fGC_Toggle_Head_BinName_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGC_Toggle_Head_BinName_OnRowClick(newSelectionModel);
    }
  };

  //GC CustomerSearch End

  //bin end

  return (
    <div className="container-fluid ">
      <div className="Breadcrumbs">
        <WmsPutAwayBreadCrumbs />
      </div>
      <div className="">
        {vMediaQuery ? (
          " "
        ) : (
          <WmsHead xref={BarcodeFocusOnLoad} vRdxHead={vRdxHead} />
        )}

        <WmsContent
          sEnterKeyObj={sEnterKeyObj}
          xContent_Focus={fContent_Focus}
          xContent_Blur={fContent_Blur}
          xBufferObj={sBufferObj}
          sUnit={sUnit}
          fUnit={fUnit}
          fQty={fQty}
          fQty_Enter={fQty_Enter}
          fCardId={(e) => {
            setBufferObj((obj) => ({
              ...obj,
              B_CardId: e.target.value,
            }));
          }}
          fCardIdEnter={fCardIdEnter}
          //GC toggle
          fItemName={GCToggleSearch_ItemName_Main_Input} //onchange main input
          xMediaQuery={vMediaQuery} //mobile screen
          xonClickbtn={GCToggleSearch_ItemName_Main_Enter} // onclick icon open div on main screen
          xrows={GCToggleSearch_ItemName_Grid_Row} //Grid Row GCToggle Search from API
          xcolumns={GCToggleSearch_ItemName_Columns} //GCToggleSearch-Grid col GCToggle Search fron Action
          xRowCellClick={GCToggleSearch_ItemName_CellClick} //GCToggleSearch-grid clic
          xRowClick={GCToggleSearch_ItemName_RowClick} //GCToggleSearch- grid click
          xToggle={GCToggleSearch_ItemName_Toggle} //GCToggleSearch-to show div using true/false (after xonClickbtn state value will be passed)
          xData={GCToggleSearch_ItemName_Select_Arr} // GCToggleSearch-select-tag arr
          xOnChangeDropdownInput={GCToggleSearch_ItemName_Sub_Input} //GCToggleSearch-input search onchane DATA/TYPE
          xDropdownObj={GCToggleSearch_ItemName_Obj} // GCToggleSearch-object DATA/TYPE
          xOnKeyUpDropdownInput={GCToggleSearch_ItemName_Sub_Enter} //GCToggleSearch-
          //bin
          xGC_Toggle_Head_BinName_DropDown_Arr={["Any", "Code", "Name"]} //sub input arr
          xfGC_Toggle_Head_BinName_Name={(e) => {
            setBufferObj((obj) => ({
              ...obj,
              B_BinName: e.target.value,
              B_CardId: "",
            }));
          }} //onchange main input
          xGC_Toggle_Head_BinName_Toggle={
            sGC_Toggle_Head_BinName_ToggleDropDowm
          } //boolean true  false
          xGC_Toggle_Head_BinName_onKeyUp={fGC_Toggle_Head_BinName_onKeyUp} //main input enter
          xGC_Toggle_Head_BinName_SearchDropdownObj={
            sGC_Toggle_Head_BinName_SearchDropdownObj
          } //sub input obj
          xGC_Toggle_Head_BinName_Dropdown_onChange={
            fGC_Toggle_Head_BinName_Dropdown_onChange
          } //sub input onchange
          xGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load={
            fGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load
          } //sub input load
          xGC_Toggle_Head_BinName_GridColumns={[
            { field: "id", headerName: "ID", width: 70, hide: true },
            { field: "UId", headerName: "Code", width: 90 },
            { field: "Name1", headerName: "Name1", flex: 1 },
            { field: "BinAttr1", headerName: "BinAttr1", flex: 1 },
            // { field: "Name1", headerName: "Name1", width: 220 },
          ]} //sub input col
          xGC_Toggle_Head_BinName_GridData={sGC_Toggle_Head_BinName_GridData} //sub input grid
          xfGC_Toggle_Head_BinName_OnCellKeyDown={
            fGC_Toggle_Head_BinName_OnCellKeyDown
          } //sub input row enter
          xfGC_Toggle_Head_BinName_OnRowClick={
            fGC_Toggle_Head_BinName_OnRowClick
          } //sub input row click
          //bin end
        />
        <Grid
          container
          className="my-2"
          spacing={{ xs: 0.5, sm: 1, md: 0 }}
          columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
          sx={{
            alignItems: "center",
            justifyContent: vMediaQuery ? "start" : "center",
          }}
        >
          <Grid item xs={4} sm={2.5} md={2.2} lg={2.2}>
            <CmpButton
              xbtnName="New"
              xOnClick={fNew}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xId={"IdNew"}
              xSendIcon={<AddBoxRoundedIcon />}
            />
          </Grid>
          <Grid item xs={4} sm={2.5} md={2.2} lg={2.2}>
            <CmpButton
              xbtnName="Save"
              xOnClick={fSave}
              xVariant="contained"
              xDisabled={vRdxHead.A_DocStat !== "ENTER"}
              xSize="small"
              xId={"IdSave"}
              xSendIcon={<SaveRoundedIcon />}
            />
          </Grid>
          <Grid item xs={4} sm={2.5} md={2.2} lg={2.2}>
            <CmpButton
              xbtnName="Delete"
              xOnClick={fDelete}
              xVariant="contained"
              xDisabled={vRdxHead.A_DocStat !== "ENTER"}
              xSize="small"
              xId="IdDelete"
              xSendIcon={<DeleteRoundedIcon />}
            />
          </Grid>

          <Grid
            item
            xs={4}
            sm={2.5}
            md={2.2}
            lg={2.2}
            className="xs-dontShowInMobileView"
          >
            <CmpButton
              xbtnName="Approve"
              xOnClick={fApprove}
              xVariant="contained"
              xDisabled={vRdxHead.A_DocStat !== "ENTER"}
              xSize="small"
              xId={"IdApprove"}
              // xSendIcon={<CheckCircleOutlineRoundedIcon />}
            />
          </Grid>

          <Grid
            item
            xs={4}
            sm={2.5}
            md={2.2}
            lg={2.2}
            className="xs-screen-hide"
          >
            <DropdownButton
              id="dropdown-basic-button"
              title="Print"
              variant="primary"
              size="xs"
            >
              <Dropdown.Item
                id="IdPrint"
                onClick={(e) => {
                  fPrint("PUAWAY_GRN");
                }}
              >
                Putaway Vs GRN
              </Dropdown.Item>
              <Dropdown.Item
                onClick={(e) => {
                  fPrint("PUAWAY_DTL");
                }}
              >
                Putaway Detail
              </Dropdown.Item>
            </DropdownButton>
          </Grid>
          <Grid
            item
            xs={4}
            sm={2.5}
            md={2.2}
            lg={2.2}
            className="bintransfer-btn-grid-sm-show"
          >
            <CmpButton
              xbtnName="Detail"
              xOnClick={fView}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xSendIcon={<RemoveRedEyeIcon />}
            />
          </Grid>
          <Grid
            item
            xs={4}
            sm={2.5}
            md={2.2}
            lg={2.2}
            className="bintransfer-btn-grid-sm-show"
          >
            <CmpButton
              xbtnName="Summary"
              xOnClick={fSummary}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xSendIcon={<RemoveRedEyeIcon />}
            />
          </Grid>
        </Grid>
        <div className="mt-5 xs-screen-hide">
          <Box sx={{ height: "50vh", width: "100%" }}>
            <DataGrid
              rowHeight={30}
              headerHeight={40}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? "mui-even-row"
                  : "mui-odd-row"
              }
              sx={{
                border: 1,
                borderColor: "primary.light",
              }}
              rows={sDetail_Grid_Row}
              columns={Detail_Grid_columns}
              hideFooter={sDetail_Grid_Row.length < 100}
              onRowClick={fDetail_Grid_onRowClick}
              components={{
                Toolbar: vMediaQuery ? "" : GridToolbar,
              }}
            />
          </Box>
        </div>
      </div>
      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Grid"} onClose={fCloseViewModal} />

          <div className="py-3">
            <div style={{ height: "69vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sDetail_Grid_Row}
                columns={Detail_Grid_columns}
                hideFooter={sDetail_Grid_Row.length < 100}
                onRowClick={fDetail_Grid_onRowClick}
              />
            </div>
          </div>
        </Box>
      </Modal>

      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary "} onClose={fCloseSummaryModal} />

          <div className="py-3">
            <WmsHead xref={BarcodeFocusOnLoad} vRdxHead={vRdxHead} />
          </div>
        </Box>
      </Modal>
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </div>
  );
}
